import React, { useState } from "react";
import { Icon } from "../../";
import BusinessSelectionModal from "../../POS/BusinessSelectionModal";
import { usePostHog, useIntercom } from "@finitless/shared/hooks";
import { useTranslation } from "react-i18next";

const SalesChannelCard = ({ integration }) => {
  const { t } = useTranslation("integrations");
  const { name, logo, plugin } = integration;
  const { isFeatureEnabled } = usePostHog();
  const { showMessenger } = useIntercom();
  const salesChannelsConfigureEnabled = isFeatureEnabled(
    "sales_channels_configure_enabled",
  );

  const [isBusinessModalOpen, setIsBusinessModalOpen] = useState(false);

  const handleConfigure = (e) => {
    e.stopPropagation();
    setIsBusinessModalOpen(true);
  };

  return (
    <div className="flex h-full flex-col rounded-lg border border-gray-800 bg-gray-900 p-6 transition-colors hover:bg-gray-800/50">
      {/* Header */}
      <div className="mb-4">
        <div className="mb-3 flex items-start justify-between">
          <div className="flex items-center space-x-3">
            {logo ? (
              <div className="flex h-12 w-12 flex-shrink-0 items-center justify-center overflow-hidden rounded-lg border border-gray-700 bg-gray-800">
                <img
                  src={logo}
                  alt={name}
                  className="h-full w-full object-cover"
                  onError={(e) => {
                    e.target.style.display = "none";
                    e.target.nextSibling.style.display = "flex";
                  }}
                />
                <div className="flex hidden h-full w-full items-center justify-center bg-gray-700 text-xs font-semibold text-white">
                  {name.charAt(0)}
                </div>
              </div>
            ) : (
              <div className="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-lg border border-gray-700 bg-gray-800">
                <Icon name="ShoppingCart" className="h-6 w-6 text-gray-400" />
              </div>
            )}
            <div className="min-w-0 flex-1">
              <h3 className="mb-1 text-lg font-semibold text-white">{name}</h3>
              {/* Description */}
              <p className="text-sm text-gray-400">
                {plugin?.description || "Sales channel integration platform"}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Actions */}
      <div className="mt-auto space-y-2 border-t border-gray-800 pt-4">
        {salesChannelsConfigureEnabled ? (
          <button
            onClick={handleConfigure}
            className="flex w-full items-center justify-center rounded-lg bg-gradient-to-r from-blue-600 to-purple-600 px-4 py-2 text-sm font-medium text-white transition-colors hover:from-blue-700 hover:to-purple-700"
          >
            <span>Configure</span>
          </button>
        ) : (
          <button
            onClick={(e) => {
              e.stopPropagation();
              showMessenger();
            }}
            className="flex w-full items-center justify-center rounded-lg bg-gray-700 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-gray-600"
          >
            <Icon name="MessageCircle" className="mr-2 h-4 w-4" />
            <span>{t("contactUs")}</span>
          </button>
        )}
      </div>

      {/* Business Selection Modal */}
      <BusinessSelectionModal
        isOpen={isBusinessModalOpen}
        onClose={() => setIsBusinessModalOpen(false)}
        integration={integration}
        integrationType="sales_channel"
      />
    </div>
  );
};

export default SalesChannelCard;
